import { useCallback, useEffect, useState } from "react";
import { api } from "./lib/api.js";
import { assinarPush, podeReceberPush } from "./lib/push.js";
import { Login } from "./screens/Login.js";
import { Painel } from "./screens/Painel.js";
import { Foto } from "./screens/Foto.js";
import { Peso } from "./screens/Peso.js";
import { CheckIn } from "./screens/CheckIn.js";
import { ImportarSaude } from "./screens/ImportarSaude.js";
import { PareaAndroid } from "./screens/PareaAndroid.js";

type Tela = "painel" | "foto" | "peso" | "checkin" | "importar" | "parear";

export function App() {
  const [sessao, setSessao] = useState<"verificando" | "fora" | "dentro">("verificando");
  const [tela, setTela] = useState<Tela>("painel");
  // `versao` força o painel a remontar depois de um registro, para os números
  // refletirem o que acabou de entrar sem precisar de gerência de estado global.
  const [versao, setVersao] = useState(0);
  const [avisoPush, setAvisoPush] = useState<string | null>(null);

  useEffect(() => {
    api
      .get("/me")
      .then(() => setSessao("dentro"))
      .catch(() => setSessao("fora"));
  }, []);

  useEffect(() => {
    if (sessao !== "dentro") return;
    // Atalhos do manifesto: abrir direto na ação.
    const acao = new URLSearchParams(window.location.search).get("acao");
    if (acao === "foto") setTela("foto");
    if (acao === "peso") setTela("peso");
    if (acao === "checkin") setTela("checkin");
    if (acao === "importar") setTela("importar");
    if (acao === "parear") setTela("parear");
  }, [sessao]);

  const aoEntrar = useCallback(async () => {
    setSessao("dentro");
    const check = podeReceberPush();
    if (!check.pode) return setAvisoPush(check.motivo);
    const r = await assinarPush();
    if (!r.ok) setAvisoPush(r.motivo ?? null);
  }, []);

  const voltarAoPainel = useCallback(() => {
    setTela("painel");
    setVersao((v) => v + 1);
  }, []);

  if (sessao === "verificando") {
    return <div className="grid min-h-dvh place-items-center text-suave">…</div>;
  }
  if (sessao === "fora") return <Login aoEntrar={aoEntrar} />;

  return (
    <>
      {avisoPush && (
        <div className="bg-mostarda/15 px-4 py-3 text-sm">
          <p>{avisoPush}</p>
          <button className="mt-1 text-xs underline" onClick={() => setAvisoPush(null)}>
            entendi
          </button>
        </div>
      )}

      {tela === "painel" && (
        <Painel
          key={versao}
          aoAbrirFoto={() => setTela("foto")}
          aoAbrirPeso={() => setTela("peso")}
          aoAbrirCheckIn={() => setTela("checkin")}
          aoAbrirImportacao={() => setTela("importar")}
          aoAbrirPareamento={() => setTela("parear")}
        />
      )}
      {tela === "foto" && <Foto aoFechar={voltarAoPainel} />}
      {tela === "peso" && <Peso aoFechar={voltarAoPainel} />}
      {tela === "checkin" && <CheckIn aoFechar={voltarAoPainel} />}
      {tela === "importar" && <ImportarSaude aoFechar={voltarAoPainel} />}
      {tela === "parear" && <PareaAndroid aoFechar={voltarAoPainel} />}
    </>
  );
}
